import { Feather } from '@expo/vector-icons';
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { RectButton } from 'react-native-gesture-handler';
import Text from '../Text';
import { WhatsappGuest } from '_/screens/EditMeeting';

interface Props {
  guest: WhatsappGuest;
  removeTag: (phone: string) => void;
}

export default function WhatsappTag({ guest, removeTag }: Props) {
  return (
    <View style={styles.container}>
      <View>
        <Text style={styles.name}>{guest.name}</Text>
        <Text style={styles.phone}>{guest.phone}</Text>
      </View>

      <RectButton onPress={() => removeTag(guest.phone)}>
        <Feather name="x" size={16} />
      </RectButton>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#EAEAEA',
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
  },
  name: {
    fontWeight: 'bold',
  },
  phone: {
    fontSize: 12,
    color: '#666',
  },
});
